var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBill = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 30,
  height: 30,
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.5488 7.74219C13.549 9.87981 15.2813 11.6131 17.4189 11.6133H24.6773C24.9445 11.6133 25.1611 11.8299 25.1611 12.0972V27.0967C25.1611 28.7001 23.8612 30 22.2578 30H7.74219C6.13878 30 4.83887 28.7001 4.83887 27.0967V2.90332C4.83887 1.29991 6.13976 0 7.74316 0H13.065C13.3322 0 13.5488 0.216636 13.5488 0.483871V7.74219Z",
  fill: "#D20071"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M24.1286 8.85125C24.4334 9.15607 24.2175 9.67727 23.7864 9.67727H18.3872C16.7838 9.67727 15.4839 8.37736 15.4839 6.77395V1.37473C15.4839 0.943651 16.0051 0.727763 16.3099 1.03259L24.1286 8.85125Z",
  fill: "#D20071"
})));
export default SvgBill;